import {
  OPPORTUNITIES_FETCH_SUCCESS,
} from '../actionTypes';

let initialState = []

export default function opportunities(state = initialState, action) {
  switch(action.type) {
    case OPPORTUNITIES_FETCH_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/projectFinder/reducers/opportunities.js